// extracted by mini-css-extract-plugin
export default {"white":"#fff","spinner":"style_spinner__AO3V+","spinAnimate":"style_spinAnimate__pGT66"};